import { Component, OnInit } from '@angular/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { TranslateService } from '@ngx-translate/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  aboutUsHtml = '';

  constructor(
    private pageService: InformationPageService, 
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService, private title: Title) { }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(
      lang => {this.initContent(lang.lang);}
    );   
    this.initContent(null);
 
    this.translate.get('title_about_us').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  private initContent(lang: string): void{
    if(lang == null){
      lang = this.browserStorageService.get("_lang");
      if(lang == null || lang == ''){
        lang = 'pl';
      }
    }
    this.pageService.getInformationPage(this.pageService.PAGES.ABOUT_US, lang).subscribe( (response: any) => {
      this.aboutUsHtml = response.data.page[Object.keys(response.data.page)[0]];
    }
    );
  }

}


